import { PageMeta } from "@/components/common/Seo/PageMeta"
import HomePage from "@/components/home/HomePage"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "Token Terminal | Fundamentals for crypto",
        description:
          "Standardized financial and usage metrics for blockchains, apps and tokenized assets. Compare fees, revenue and users across crypto. Start exploring for free.",
      }}
    />
    <HomePage />
  </>
)

export default index
